export default "__VITE_ASSET__BdvVOOEf__"